import { render, staticRenderFns } from "./DetailsRole.vue?vue&type=template&id=347d937e&scoped=true"
import script from "./DetailsRole.vue?vue&type=script&lang=js"
export * from "./DetailsRole.vue?vue&type=script&lang=js"
import style0 from "./DetailsRole.vue?vue&type=style&index=0&id=347d937e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347d937e",
  null
  
)

export default component.exports